// extracted by mini-css-extract-plugin
export var aiStarIcon = "_so-2";
export var container = "_so-4";
export var dismissButton = "_so-3";
export var hasPaddingBottom = "_so-6";
export var last = "_so-e";
export var scrollbarThumb = "_so-c";
export var scrollbarTrack = "_so-b";
export var selected = "_so-9";
export var spin = "_so-1";
export var spinning = "_so-0";
export var suggestionItem = "_so-d";
export var suggestionsPanel = "_so-5";
export var tonePill = "_so-8";
export var tonesContainer = "_so-7";
export var unselected = "_so-a";